import { formatCurrency } from '@sportninja/common/currency'
import type { OfficialEffectTarget } from '../types/officialEffect'
import { dollarsToMinor } from './balanceMath'
import { balanceLabel, balanceText } from './balanceI18n'

/**
 * Sep 23 — what the confirm for a change to a team official's line says: its title,
 * the sentence above the list of player shares it moves, and its button.
 */
export const officialEffectCopy = (
  target: OfficialEffectTarget
): { title: string; intro: string; confirmLabel: string } => {
  const money = (dollars: number) =>
    formatCurrency({
      amount: dollarsToMinor(dollars),
      currencyCode: target.currencyCode,
    })

  if (target.kind === 'removal') {
    return {
      title: balanceLabel('common:balanceRemoveAddedInvoiceTitle'),
      intro: balanceText('common:balanceOfficialRemovalIntro', {
        name: target.name,
        amount: money(target.bill.subtotal),
      }),
      confirmLabel: balanceText(
        'common:balanceRemoveAddedInvoiceConfirm'
      ).toUpperCase(),
    }
  }

  return {
    title: balanceLabel('common:balanceOfficialConfirmTitle'),
    intro: balanceText('common:balanceOfficialAmountIntro', {
      name: target.kind === 'create' ? target.row.candidate.name : target.name,
      amount: money(target.amount),
    }),
    confirmLabel: balanceText(
      'common:balanceOfficialConfirmAction'
    ).toUpperCase(),
  }
}
